// Shared FX bus (docs/04 §4.8). A send/return: each layer channel sends a
// portion of its signal to this rack, which filters → delays → reverbs the sum
// and returns it to the destination in parallel with the dry mix.

import * as Tone from "tone";

export const FX_BUS = "fx";

export class FxRack {
  private readonly input: Tone.Channel;
  private readonly filter: Tone.Filter;
  private readonly delay: Tone.FeedbackDelay;
  private readonly reverb: Tone.Freeverb;

  constructor(destination: Tone.ToneAudioNode) {
    this.input = new Tone.Channel();
    this.input.receive(FX_BUS); // layer channels send here by name
    this.filter = new Tone.Filter({ type: "lowpass", frequency: 12000, Q: 0.5 });
    this.delay = new Tone.FeedbackDelay({ delayTime: "8n", feedback: 0.32, wet: 0.35 });
    this.reverb = new Tone.Freeverb({ roomSize: 0.85, dampening: 2000, wet: 0.6 });
    this.input.chain(this.filter, this.delay, this.reverb, destination);
  }

  /** 0..1 reverb mix on the return. */
  setReverb(amount: number): void {
    this.reverb.wet.rampTo(clamp01(amount), 0.1);
  }
  /** 0..1 delay mix on the return. */
  setDelay(amount: number): void {
    this.delay.wet.rampTo(clamp01(amount), 0.1);
  }
  /** Return-filter cutoff in Hz. */
  setFilter(hz: number): void {
    this.filter.frequency.rampTo(hz, 0.1);
  }

  dispose(): void {
    this.input.dispose();
    this.filter.dispose();
    this.delay.dispose();
    this.reverb.dispose();
  }
}

function clamp01(v: number): number {
  return Math.max(0, Math.min(1, v));
}
